export default __webpack_public_path__ + "static/media/img-17.786f5d37.jpg";